import { Phone, MapPin, Clock, Shield } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#1A202C] py-16">
      <div className="section-container">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <div className="mb-6">
              <img 
                src="/logo-footer-light.svg" 
                alt="Brunswick Glass" 
                className="h-20 w-auto object-contain"
              />
            </div>
            <p className="font-body text-white/60 leading-relaxed max-w-sm">
              Serving coastal North Carolina with quality glass solutions for over 30 years. Custom showers, mirrors, windows, and commercial glass.
            </p>
          </div>
          <div>
            <h4 className="font-heading text-lg font-medium text-white mb-4">Services</h4>
            <ul className="space-y-2">
              <li><a href="#services" className="font-body text-white/60 hover:text-white transition-colors">Custom Showers</a></li>
              <li><a href="#services" className="font-body text-white/60 hover:text-white transition-colors">Window Replacement</a></li>
              <li><a href="#services" className="font-body text-white/60 hover:text-white transition-colors">Custom Mirrors</a></li>
              <li><a href="#services" className="font-body text-white/60 hover:text-white transition-colors">Commercial Glass</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-lg font-medium text-white mb-4">Contact</h4>
            <ul className="space-y-2">
              <li>
                <a href="tel:910-457-4757" className="font-body text-white/60 hover:text-white transition-colors flex items-center gap-2">
                  <Phone className="w-4 h-4" /> 910-457-4757
                </a>
              </li>
              <li className="font-body text-white/60 flex items-center gap-2">
                <MapPin className="w-4 h-4" /> Coastal North Carolina
              </li>
              <li className="font-body text-white/60 flex items-center gap-2">
                <Clock className="w-4 h-4" /> Mon-Fri: 8AM - 5PM
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-body text-sm text-white/40">
            © 2026 Brunswick Glass. All rights reserved.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
            <div className="flex items-center gap-2">
              <Shield className="w-4 h-4 text-white/40" />
              <span className="font-body text-sm text-white/40">Licensed & Insured</span>
            </div>
            <Link 
              to="/website-accessibility"
              className="font-body text-sm text-white/40 hover:text-white/60 transition-colors"
            >
              WCAG Accessibility Statement
            </Link>
            <a 
              href="https://bp.agency" 
              target="_blank" 
              rel="noopener noreferrer"
              className="font-body text-sm text-white/40 hover:text-white/60 transition-colors"
            >
              Website Designed By Brand Partners
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
